import AppContext from 'App/AppContext';
import { CopilotPanelContext } from 'models/copilot/copilotBridge';
import { useCopilotContext } from 'models/copilot/copilotContext';
import { CopilotGenericContent } from 'models/copilot/copilotGeneric';
import { CopilotScene } from 'models/copilot/copilotScene';
import { useContext, useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';

const copilotDeepLinkQueryParam = 'copilot';
const copilotSessionIdQueryParam = 'sessionId';
const copilotApprovalIdQueryParam = 'approvalId';

const hasCopilotDeepLinkQuery = (search: string): boolean => {
  const searchParams = new URLSearchParams(search);

  return (
    searchParams.get(copilotDeepLinkQueryParam) === '1' ||
    searchParams.has(copilotSessionIdQueryParam) ||
    searchParams.has(copilotApprovalIdQueryParam)
  );
};

const CopilotDashboardDeepLinkActivator = () => {
  const appContext = useContext(AppContext);
  const { search } = useLocation();
  const [isDeepLinkActive, setIsDeepLinkActive] = useState<boolean>(() => hasCopilotDeepLinkQuery(search));
  const copilotContent = useMemo(() => {
    const content = new CopilotGenericContent();
    content.scene = CopilotScene.Dashboard;

    return content;
  }, []);

  useEffect(() => {
    if (hasCopilotDeepLinkQuery(search)) {
      setIsDeepLinkActive(true);
    }
  }, [search]);

  // the dashboard always offers its questions; a deep link also opens the panel. TrialWelcome activates later on
  // /dashboard/welcome and wins there.
  useCopilotContext(appContext.copilotBridge, CopilotPanelContext.Generic, copilotContent, {
    forceOpen: isDeepLinkActive,
  });

  return null;
};

export default CopilotDashboardDeepLinkActivator;
